import { useState } from "react";
import { useApi, img } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { PageHeader } from "@/components/site/Reveal";
import { Lightbox } from "@/components/site/Lightbox";
import { useLang } from "@/lib/i18n";

export default function Gallery() {
  const { t, L } = useLang();
  const { data } = useApi("/gallery", []);
  const [idx, setIdx] = useState(null);
  const photos = data.map((g) => ({ src: g.image, alt: L(g, "caption") || "Escamequita, Nicaragua" }));
  return (
    <>
      <Seo title={t("gallery.seoTitle")} description={t("gallery.seoDesc")} />
      <PageHeader testId="gallery-header" eyebrow={t("gallery.eyebrow")} title={t("gallery.title")} />
      <section className="container-x pb-28">
        <div className="columns-1 gap-5 sm:columns-2 lg:columns-3" data-testid="gallery-grid">
          {data.map((g, i) => (
            <button key={g.id} onClick={() => setIdx(i)} className="img-zoom group relative mb-5 block w-full overflow-hidden rounded-2xl" data-testid={`gallery-item-${i}`}>
              <img src={img(g.image)} alt={L(g, "caption")} loading="lazy" className="w-full object-cover" />
              {g.caption && (
                <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4 text-left text-sm font-bold text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">{L(g, "caption")}</span>
              )}
            </button>
          ))}
        </div>
      </section>
      {idx !== null && <Lightbox images={photos} index={idx} onChange={setIdx} onClose={() => setIdx(null)} />}
    </>
  );
}
